import ipc from '@/utils/ipc'

export const state = () => ({
  getDataFromNutrilabMilliseconds: null,
  updateAvailable: false,
  noNutrilabPro: false,
})

export const getters = {
  getDataFromNutrilabMilliseconds: (state) =>
    state.getDataFromNutrilabMilliseconds,
  getNoNutrilabPro: (state) => state.noNutrilabPro,
}

export const mutations = {
  setUpdateAvailable(state, value) {
    state.updateAvailable = value
  },
  setGetDataFromNutrilabMilliseconds(state, value) {
    state.getDataFromNutrilabMilliseconds = value
  },
  setNoNutrilabPro(state, value) {
    state.noNutrilabPro = value
  },
}

export const actions = {
  async getConfig({ commit, rootGetters }) {
    try {
      if (process.env.platform === 'electron') {
        const { data } = await this.$axios.post(
          `${rootGetters['network/localAPI']}/config/get`,
          {}
        )

        commit(
          'setGetDataFromNutrilabMilliseconds',
          data.getDataFromNutrilabMilliseconds
        )
        commit('setNoNutrilabPro', data.noNutrilabPro)
        setTimeout(() => {
          ipc('checkForUpdates', {
            silent: true,
            locale: this.$i18n.localeProperties.code,
          })
        }, 1000)
      }

      if (rootGetters['utils/isShared']) {
        this.$axios.defaults.baseURL = rootGetters['network/localAPI']
      } else {
        this.$axios.defaults.baseURL = rootGetters['network/onLine']
          ? process.env.baseUrl
          : rootGetters['network/localAPI']
      }
    } catch (error) {
      console.error(error)
    }
  },
}
